import axios from "axios";
import { endPoints } from "../../constant/api_constants/url";
import { RADAR } from "../../constant/environment";
import { isValidJWT } from "../../utils/authentication/isValidJWT";

export async function getUserLocationAPI(accessJWT: string) {
  try {
    if (!accessJWT || !isValidJWT(accessJWT)) return null;
    const { data } = await axios.get(endPoints.getUserLocation, {
      headers: {
        Authorization: RADAR.API_KEY,
      },
    });
    return data ? data : null;
  } catch (err: any) {
    return null;
  }
}
